import React, { useEffect, useState } from "react";
import "./styles.scss";
import {
  useCreateModelDataMutation,
  useDeleteModelInfoMutation,
  useGetAllModelDataQuery,
  useGetBrandDataQuery,
  useGetThemeDataQuery,
} from "../../../Services/vehicle/Vehicle";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import EditModel from "./EditModel";
import DeleteModal from "../DeleteModal";
import useThemeColors from "../ThemeColors";
import LoadingSpinner from "../../../components/LoadingSpinner";

interface IPROPS {
  setLiftingName: any;
}

const ITEMS_PER_PAGE = 20;

const Model: React.FC<IPROPS> = ({ setLiftingName }) => {
  const [brandName, setBrandName] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState<number>();
  const [model, setModel] = useState("");
  const [vehicleTableData, setVehicleTableData] = useState([]);
  const [carModelData, setCarModelData] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [storedData, setStoredData] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalCount] = useState(0);
  const [tableLoader, setTableLoader] = useState(false);
  const { selectedButtonBackgoundColors } = useThemeColors();

  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItems);

  const name = "Vehicle Information";

  useEffect(() => {
    setLiftingName(name);
  }, [setLiftingName]);

  const [createVehicleTrigger] = useCreateModelDataMutation();
  const {
    data: modelData,
    status: modelStatus,
    refetch: modelRefetch,
    isLoading: modelLoading,
  } = useGetAllModelDataQuery({
    page: currentPage,
    page_size: ITEMS_PER_PAGE,
    brand: selectedBrand,
  });
  const [deleteTrigger] = useDeleteModelInfoMutation();

  useEffect(() => {
    if (modelStatus === "pending") {
      setTableLoader(true);
    } else {
      setTableLoader(false);
    }
  }, [modelStatus]);

  const {
    data: vehicleData,
    status,
    refetch,
    isLoading,
  } = useGetBrandDataQuery({});

  useEffect(() => {
    if (vehicleData) {
      setVehicleTableData(vehicleData);
    }
  }, [vehicleData]);

  useEffect(() => {
    if (modelData) {
      setCarModelData(modelData?.results || []);
      console.log(modelData);
      setTotalCount(modelData?.count || 0);
    }
  }, [modelData]);

  const createVehicleDataHandler = async () => {
    const obj = {
      brand_id: brandName,
      name: model,
    };

    try {
      const response: any = await createVehicleTrigger(obj);

      if (response?.data) {
        toast.success("Data added successfully");
        setBrandName("");
        setModel("");
        modelRefetch();
      } else if (response?.error) {
        const errorData = response.error?.data;

        if (errorData?.non_field_errors?.length > 0) {
          toast.error(errorData.non_field_errors[0]);
        } else if (errorData?.detail) {
          toast.error(errorData.detail);
        } else {
          toast.error("Unable to add vehicle data");
        }
      }
    } catch (error) {
      toast.error("An unexpected error occurred");
    }
  };

  const editHandler = (vehicle) => {
    setOpenEditModal(true);
    setStoredData(vehicle);
  };

  const closeModal = () => {
    setOpenEditModal(false);
    setOpenDeleteModal(false);
  };

  const handleResetFilters = () => {
    setSelectedBrand(null);
    setCurrentPage(1);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
  };

  const deleteHandler = (vehicle) => {
    setStoredData(vehicle);
    setOpenDeleteModal(true);
  };
  const { selectedColor, selectedButtonColors } = useThemeColors();

  const isSaveDisabled = !brandName || model.trim() === "";

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="vehicle-info-cont">
      <div className="workshops-container">
        {/* Add Model Section */}
        <div
          className="vehicle-info-middle"
          style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
        >
          <div
            className="vehicle-info-middle-heading"
            style={{ fontFamily: "Karbon-medium" }}
          >
            Add Model
          </div>
          <div
            className="vehicle-info"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-end",
                gap: "10px",
              }}
            >
              <div className="vehicle-class" style={{ flex: 1 }}>
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    fontFamily: "Karbon-medium",
                    fontSize: "18px",
                  }}
                >
                  Brand
                </span>
                <select
                  style={{
                    borderRadius: "20px",
                    background: "#FCFCFC",
                    fontFamily: "Karbon-regular",
                  }}
                  className="form-control"
                  onChange={(e) => setBrandName(e.target.value)}
                  value={brandName || ""}
                >
                  <option value="">Select Brand</option>
                  {vehicleTableData?.map((brand, index) => (
                    <option key={brand?.id || index} value={brand?.id}>
                      {brand?.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="vehicle-class" style={{ flex: 1 }}>
                <span
                  className="required"
                  style={{
                    paddingLeft: "10px",
                    fontFamily: "Karbon-medium",
                    fontSize: "18px",
                  }}
                >
                  Model
                </span>
                <input
                  style={{
                    borderRadius: "20px",
                    background: "#FCFCFC",
                    fontFamily: "Karbon-regular",
                  }}
                  placeholder="Add Model"
                  className="form-control"
                  type="text"
                  onChange={(e) => setModel(e.target.value)}
                  value={model}
                />
              </div>

              <button
                onClick={createVehicleDataHandler}
                disabled={isSaveDisabled}
                style={{
                  background: isSaveDisabled
                    ? "#F7D3C5"
                    : `${selectedButtonBackgoundColors}`,
                  color: `${selectedButtonColors}`,
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "20px",
                  fontSize: "15px",
                  cursor: isSaveDisabled ? "not-allowed" : "pointer",
                  height: "40px",
                  whiteSpace: "nowrap",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>

        {/* Table Section with Filters */}
        {tableLoader ? (
          <LoadingSpinner />
        ) : (
          <div
            className="vehicle-info-bottom mt-10"
            style={{
              boxShadow: `${selectedColor}80 1px 1px 10px 1px`,
              overflow: "hidden",
              paddingBottom: "1px",
            }}
          >
            {/* Heading and Filters in same row */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "",
                padding: "16px 30px",
                borderBottom: "1px solid #D9D9D9",
              }}
            >
              <div
                className="vehicle-info-bottom-heading"
                style={{
                  padding: "0",
                  border: "none",
                }}
              >
                Model
              </div>

              {/* Filters Row */}
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                }}
              >
                <FormControl
                  sx={{
                    minWidth: 200,
                    maxWidth: 200,
                    "& .MuiInputBase-root": { fontFamily: "Karbon-medium" },
                  }}
                  size="small"
                >
                  <InputLabel sx={{ fontFamily: "Karbon-medium" }}>
                    Brand
                  </InputLabel>
                  <Select
                    value={selectedBrand || ""}
                    onChange={(e) => {
                      setSelectedBrand(e.target.value as number);
                      setCurrentPage(1);
                    }}
                    label="Brand"
                    sx={{
                      "& .MuiSelect-select": {
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        maxWidth: "180px",
                        padding: "8px 32px 8px 12px",
                        fontSize: "0.875rem",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          width: 200,
                        },
                      },
                    }}
                  >
                    <MenuItem value="" sx={{ fontFamily: "Karbon-medium" }}>
                      All Brands
                    </MenuItem>
                    {vehicleTableData?.map((brand) => (
                      <MenuItem
                        key={brand.id}
                        value={brand.id}
                        sx={{ fontFamily: "Karbon-medium" }}
                      >
                        {brand.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  variant="contained"
                  onClick={handleResetFilters}
                  sx={{
                    fontFamily: "Karbon-medium",
                    fontSize: "14px",
                    textTransform: "none",
                    backgroundColor: "#FF6B35",
                    borderRadius: "4px",
                    padding: "8px 20px",
                    height: "40px",
                    "&:hover": {
                      backgroundColor: "#E65A2B",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    },
                    "&:active": {
                      boxShadow: "none",
                      transform: "translateY(1px)",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "rgba(0, 0, 0, 0.12)",
                      color: "rgba(0, 0, 0, 0.26)",
                    },
                  }}
                  disabled={isLoading || tableLoader}
                >
                  {isLoading || tableLoader ? (
                    <CircularProgress
                      size={20}
                      sx={{ color: "inherit", mr: 1 }}
                    />
                  ) : null}
                  Reset Filters
                </Button>
              </div>
            </div>

            {/* Table */}
            <table className="vehicle-info-bottom-table">
              <thead className="thead">
                <tr
                  className="tr"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                  }}
                >
                  <td>Sr.No.</td>
                  <td>Brand</td>
                  <td style={{ textAlign: "center" }}>Model</td>
                  <td style={{ padding: "0 10px", textAlign: "end" }}>
                    Action
                  </td>
                </tr>
              </thead>
              <tbody className="table-body">
                {carModelData?.map((vehicle, index) => (
                  <tr
                    key={vehicle?.id || index}
                    className="table-body-tr"
                    style={{
                      background: index % 2 !== 0 ? "#FFF1EC" : "white",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr 1fr 1fr",
                    }}
                  >
                    <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                    <td>{vehicle?.brand?.name}</td>
                    <td style={{ textAlign: "center" }}>{vehicle?.name}</td>
                    <td style={{ textAlign: "end" }}>
                      <span
                        style={{ marginRight: "10px" }}
                        onClick={() => editHandler(vehicle)}
                      >
                        <i
                          className="bi bi-pencil"
                          style={{ fontSize: "20px", cursor: "pointer" }}
                        ></i>
                      </span>
                      {/* <span onClick={() => deleteHandler(vehicle)}>
                        <i
                          className="bi bi-trash3"
                          style={{ fontSize: "20px", cursor: "pointer" }}
                        ></i>
                      </span> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Pagination */}
        <div className="pagination-footer mb-10">
          <div className="pagination-info">
            Showing {startIndex + 1} - {endIndex} of {totalItems}
          </div>

          <div className="pagination-controls">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="pagination-btn"
            >
              Prev
            </button>

            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let firstPage = Math.max(
                1,
                Math.min(currentPage - 2, totalPages - 4)
              );

              const pageNum = firstPage + i;

              return (
                <button
                  key={pageNum}
                  onClick={() => handlePageChange(pageNum)}
                  className={`pagination-btn ${
                    pageNum === currentPage ? "active" : ""
                  }`}
                  style={{
                    display: pageNum > totalPages ? "none" : "inline-block",
                    margin: "0 2px",
                    minWidth: "32px",
                    textAlign: "center",
                  }}
                >
                  {pageNum}
                </button>
              );
            })}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="pagination-btn"
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <Modal
        open={openEditModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <EditModel
              closeModal={closeModal}
              refetchingData={modelRefetch}
              storedData={storedData}
            />
          </Box>
        </Box>
      </Modal>

      {/* Delete Modal */}
      <Modal
        open={openDeleteModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <DeleteModal
              closeModal={closeModal}
              refetchingData={modelRefetch}
              storedData={storedData}
              trigger={deleteTrigger}
              setTableData={setVehicleTableData}
              fieldsData={vehicleTableData}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default Model;
